import cx from "classnames";
import { FormattedMessage } from "react-intl";
import { animated } from 'react-spring';
import { useBlockAnimate } from '@/shared/hooks/useBlockAnimate';
import ThemeButton from '@/shared/ui/ThemeButton';
import { useNavigation } from '@/processes/Router';
import { useMinerAccount } from "@/processes/MinerAccounts";
import { loginWithRedirect } from '@/global/utils/apiHelpers';
import { BASE_HOST } from '@/shared/constants/env';
import { useDiscountRequestModal } from '~/marketing';

type IntroProps = {
  className: string;
  titleKey?: string;
  descKey?: string;
}

const Intro = (props: IntroProps) => {
  const { 
    className, 
    titleKey = 'l.shared.title',
    descKey = 'l.shared.desc',
  } = props;
  
  const { coinLower, isBTC } = useNavigation();
  const redirectAfterLogin = `${BASE_HOST}/${coinLower}/dashboard`;
  const { ref: ref1, springStyles: springTitleStyles1 } = useBlockAnimate({ intersect: true, delay: 200, top: 25, once: true });
  const { coinTitle, navigate, poolDashboardLink, coinDisplayName } = useNavigation();
  const { isAuth } = useMinerAccount();
  const { openModal: openDiscountModal } = useDiscountRequestModal();
  return (
    <div ref={ref1} className={cx(className)}>
      <animated.h1 className="text-5xl/4 sm:text-8xl font-bold mb-8 sm:mb-12" style={springTitleStyles1}>
        <FormattedMessage
          id={titleKey}
          values={{
            span: (...chunks) => (
              <span className="theme-text-highlight">{chunks}</span>
            ),
            br: <br/>,
            coin: coinDisplayName,
            coinTitle,
          }}
        />
      </animated.h1>
   
      <animated.p 
        className="text-base md:text-[28px] my-8 sm:my-16 leading-6 md:leading-9 max-w-[900px]"
        style={springTitleStyles1}
      >
        <FormattedMessage id={descKey} values={{
          coinTitle, 
        }}/>
      </animated.p>

      <div className="flex gap-4 md:gap-8 sm:items-center flex-col sm:flex-row items-start">
        {isAuth ? (
          <ThemeButton onClick={() => {
            navigate(poolDashboardLink);
          }}><FormattedMessage id="dashboard" /></ThemeButton>
        ) : isBTC ? (
          <ThemeButton 
            component='a' 
            target="_blank" 
            href={loginWithRedirect(redirectAfterLogin)}
          ><FormattedMessage id="l.btn.cta.v1" values={{ coin: coinDisplayName }} /></ThemeButton>
        ) : null}
        
        {isBTC ? (
          <ThemeButton onClick={() => openDiscountModal()}>
            <FormattedMessage id="l.btc.cta" />
          </ThemeButton>
        ): null}
      </div>
    </div>
  );
};

export default Intro;
